import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faHotel,
  faCar,
  faPersonHiking,
} from "@fortawesome/free-solid-svg-icons";
import innsbrg from "../../assets/Images/innsbrg.png";
import faroe from "../../assets/Images/faroe.png";
import hall from "../../assets/Images/hall.png";
import "../../assets/Images/ladakh.jpg";
import "../HomePage/Home.css";
import CarImage from "../../assets/Images/Car.png";
import BikeImage from "../../assets/Images/bike.png";
import HotelImage from "../../assets/Images/hotel.png";
import Nubra from "../../assets/Images/nubra.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Service from "../HomePage/Services";
import WhyChooseUs from "./WhyChooseUs";
import ClientSays from "./ClientSays";
import Glimpse from "./Glimpse";
import TravLadhak from "./TravLadhak";
import Footer from "./Footer";
import Header from "./Header";
import HotSelling from "./HotSelling";
import Nav from "./Nav";
import Destinations from "./Destinations";
// import LehbikeExpedition from "./LehbikeExpedition"; // Corrected import to match component name

const Home = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3, // Adjusted to show at least 2.5 cards on tablet screens
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };
  const carouselRef = useRef(null);
  const handleAutoplay = () => {
    setInterval(() => {
      if (carouselRef.current) {
        carouselRef.current.next();
      }
    }, 5000);
  };
  // Call autoplay function on component mount
  React.useEffect(() => {
    handleAutoplay();
  }, []);
  const handleImageClick = (imageType) => {
    // Handle the click event based on the image type
    console.log("image");
    console.log(`Clicked on ${imageType}`);
    // You can perform actions like fetching data from the backend, updating state, etc.
  };
  return (
    <div className="container-fluid p-0">
      <Nav />
      <Header />
      <div className="blackImg"></div>
      <HotSelling handleImageClick={handleImageClick} />
      <Destinations />
      <ClientSays />
      <Glimpse />
      <TravLadhak />
      <Footer />
    </div>
  );
};
export default Home;
